document.querySelectorAll('[data-pw-account]').forEach(async (root) => {
  // Liquid supplies versioned asset URLs, including for imported modules.
  try {
    const [{ CustomerClient }, { mountAccount }] = await Promise.all([
      import(root.dataset.apiModule),
      import(root.dataset.uiModule),
    ]);
    mountAccount(
      root,
      new CustomerClient({
        clientId: root.dataset.clientId,
        nativeUrl: root.dataset.nativeUrl,
        nativeLogoutUrl: root.dataset.nativeLogoutUrl,
        preferencesEnabled: root.dataset.preferencesEnabled === 'true',
      }),
    );
  } catch {
    // Restore native access if modules/storage are unavailable, without a permanent loader.
    root.querySelector('[data-pw-account-loading]')?.remove();
    const fallback = root.querySelector('[data-pw-account-fallback]');
    if (fallback) fallback.hidden = false;
    root.removeAttribute('aria-busy');
  }
});
